import CONSTANTS from '@/constants'
import api from './api'

// Promotion apis
const promotions = {
	datatable(params) {
		return api.post(`${CONSTANTS.API_BASE_URL}/api/promotions/datatable`, params)
	},
	store(params) {
		return api.post(`${CONSTANTS.API_BASE_URL}/api/promotions`, params)
	},
	get(id) {
		return api.get(`${CONSTANTS.API_BASE_URL}/api/promotions/${id}`)
	},
	update(id, formData) {
		formData.append('_method', 'PUT')

		return api.post(`${CONSTANTS.API_BASE_URL}/api/promotions/${id}`, formData)
	},
	destroy(id) {
		return api.delete(`${CONSTANTS.API_BASE_URL}/api/promotions/${id}`)
	},
}

export default promotions
